import { render, staticRenderFns } from "./BtnDownloadLocalXls.vue?vue&type=template&id=69b0d9d2&scoped=true&"
import script from "./BtnDownloadLocalXls.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadLocalXls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b0d9d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
